module.exports = __webpack_public_path__ + "static/media/solar_panel_on.0b08325d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/solar_panel_on.png
// module id = 449
// module chunks = 0